// -----------------------------------------------------------------
// P R O D U C T I O N: env configuration
// -----------------------------------------------------------------
import { Environment } from "./_environment";
import moment from "moment";

const environment: Environment = {
  version: "1.0.1",
  meetersURL: "https://www.meeters.space/",
  baseURL: "https://remtech.meeters.space",
  baseBackofficeURL: "https://backoffice-meeters-prod.firebaseapp.com",
  showHandledLogs: false,
  zoomApiKey: "movE-qA_TJ2O2UP_x6kwAA",
  jitsiURL: "https://meet.jit.si",
  whatsapp: {
    number: "390532900713",
    formatted: "+39 0532 900713",
  },
  assets: {
    meetersLogo: "/assets/images/logo_meeters_horizontal.png",
    logo: "/assets/images/logos/logo_remtech.png",
    footerLogos: [
      "/assets/images/logos/logo_remtech.png",
      "/assets/images/footer_sponsor_1.jpg",
      "/assets/images/footer_sponsor_2.png",
    ],
    userPlaceholder: "/assets/images/undraw/user_placeholder.svg",
    eventPlaceholder: "/assets/images/logo.png",
  },
  fairStartdate: moment("21/09/2020 12:00", "DD/MM/YYYY HH:mm"),
  fairEndDate: moment("31/12/2021 23:30", "DD/MM/YYYY HH:mm"),
  appointments: {
    duration: 30,
    startTime: "00:00",
    endTime: "00:00",
  },
  rooms: [
    "Africa",
    "Asia",
    "Oceania",
    "America",
    "Antartica",
    "Europe Room",
    "Technical Meetings",
    "International Club",
    "Plenary Room",
    "Auditorium",
  ],
  mattermost: {
    URL: "https://www.meeters.chat",
    generalRoom: "general",
    directMessagesPath: "general/messages",
  },
  firebase: {
    functionsURL: "https://us-central1-meeters-prod.cloudfunctions.net",
    storage: {
      buckets: {
        default: "gs://meeters-prod.appspot.com",
        resize: "gs://meeters-prod-resizable",
      },
      paths: {
        profile_images: "profile_images",
        member_images: "member_images",
        event_images: "event_images",
        stand_images: "stand_images",
      },
    },
    config: {
      apiKey: "AIzaSyDoMKOaUiBeCJoHCD1HY14mA6lLoNQZQWs",
      authDomain: "meeters-prod.firebaseapp.com",
      databaseURL: "https://meeters-prod.firebaseio.com",
      projectId: "meeters-prod",
      storageBucket: "meeters-prod.appspot.com",
      messagingSenderId: "599959032741",
      appId: "1:599959032741:web:839329829190e3dbd0ce4c",
      measurementId: "G-SCJ6CB013M",
    },
  },
};

export default environment;
